import { breakpoints } from '@kmns-internal/furikake'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import type { EditorCore } from '@react-editor-js/core/src/editor-core'
import type { TemplateManual } from '@ulysses-inc/harami_api_client'
import type React from 'react'
import { useRef } from 'react'
import { createReactEditorJS } from 'react-editor-js'
import { useDispatch } from 'react-redux'
import { editorJsCommonSettings } from 'src/features/templateEdit/common/editorJsCommonSettings'
import { updateTemplateManual as updateTemplateManualAction } from 'src/state/ducks/templates/editTemplate/actions'

const ReactEditorJS = createReactEditorJS()

interface OwnProps {
  templateManual: TemplateManual
  isOpenModal: boolean
  setIsOpenModal: (isOpenModal: boolean) => void
  onClose: () => void
  blocks: Array<any> | null
}

const EditManualModalContainer: React.FC<OwnProps> = ({
  isOpenModal,
  onClose,
  blocks,
  templateManual,
  setIsOpenModal,
}) => {
  const editorCore = useRef<EditorCore | null>(null)

  const dispatch = useDispatch()
  const updateTemplateManual = (templateManual: TemplateManual) =>
    dispatch(updateTemplateManualAction(templateManual))

  const onSubmit = async () => {
    const savedData = await editorCore.current?.save()

    // TODO error handling
    if (!savedData) return

    updateTemplateManual({ ...templateManual, blocks: savedData.blocks })
    setIsOpenModal(false)
  }

  return (
    <Dialog
      open={isOpenModal}
      onClose={onClose}
      aria-labelledby="edit-manual-dialog-title"
      slotProps={{
        transition: { unmountOnExit: true },
        paper: { sx: { minWidth: breakpoints.md } },
      }}
    >
      <DialogTitle id="edit-manual-dialog-title">マニュアルを編集</DialogTitle>
      <DialogContent>
        {blocks !== null && (
          <ReactEditorJS
            onInitialize={instance => {
              editorCore.current = instance
            }}
            tools={editorJsCommonSettings.tools}
            defaultValue={{
              time: editorJsCommonSettings.outputOption.time,
              blocks: blocks?.length
                ? blocks
                : editorJsCommonSettings.initialBlocks,
              version: editorJsCommonSettings.outputOption.version,
            }}
            placeholder="こちらをクリックして入力してください"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          キャンセル
        </Button>
        <Button variant="contained" onClick={onSubmit}>
          保存
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditManualModalContainer
